import clsx from "clsx";
import { ComponentProps, FC } from "react";
import { Anchor } from "@/components/Header/Anchor/Anchor";
import { Section } from "@/components/Html/Section";
import { PostItem } from "@/components/PostItem/PostItem";
import { TechBlog } from "@/lib/contentful/contentModel/techBlog";
import { Title } from "../Title/Title";

interface Props {
  posts: (ComponentProps<typeof PostItem>["post"] & DeepPick<TechBlog, "sys.id">)[];
  isWhiteBg?: boolean;
}

export const RelatedPosts: FC<Props> = ({ posts, isWhiteBg }) => {
  return (
    <Section
      className={clsx("kdot-container mx-auto flex flex-col !py-[32px]", isWhiteBg ? "bg-white" : "bg-[#FEF1EF]")}
    >
      <Anchor id="knowledge" />
      <Title className="mb-[32px] text-[32px] md:text-[2.5rem]" title="知見" />

      <p className="mb-[32px]">
        技術情報の発信を通して私達は自身の知識をアップデートし続けています。お客様からのご相談に対して、最新の情報で回答します。
      </p>

      <div className="grid grid-cols-1 gap-[16px] md:grid-cols-2 md:gap-[24px]">
        {posts.map((post) => (
          <PostItem key={post.sys.id} post={post} />
        ))}
      </div>
    </Section>
  );
};
